import React from 'react';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';

interface ChipProps extends Omit<MuiChipProps, 'onDelete'> {
    label: string;
    onDelete?: () => void;
    isActive?: boolean;
}

const Chip = ({ label, onDelete, isActive, ...rest }: ChipProps) => {
    return (
        <MuiChip
            label={label}
            onDelete={onDelete}
            {...rest}
            className={`chip ${isActive ? 'chipActive' : ''} ${rest.className ?? ''}`}
        />
    );
};

export default Chip;
